<template>
  <v-card>
    <v-card-title class="v-card-title">
      {{ languageData.labels.ending_projects }}
    </v-card-title>
    <v-card-text>
      <v-data-table
          :headers="headers"
          :items="data"
          :hide-default-footer="true"
          :loading="dataLoading"
          disable-pagination
          :disable-sort="$vuetify.breakpoint.xsOnly"
          mobile-breakpoint="0"
      >
      <template v-slot:item.logo="{ item }">
        <v-avatar :color="item.hexColor" size="40" class="mr-2" style="cursor: pointer" @click="previewProject(item.id)">
          <span class="white--text headline">{{ getFirstLetter(item.name) }}</span>
        </v-avatar>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
                v-bind="attrs"
                v-on="on"
                @click="previewProject(item.id)"
                icon>
              <v-icon color="fontDefault">preview</v-icon>
            </v-btn>
          </template>
          <span>{{ languageData.labels.preview }}</span>
        </v-tooltip>
      </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
import router from "../../../../../../router";

export default {
  name: "EndingProjects",
  props: {
    data: Array,
    headers: Array,
    dataLoading: Boolean,
  },
  methods: {
    getFirstLetter: function(firstname) {
      return firstname.charAt(0);
    },
    previewProject: function(id) {
      router.push({ path:"/projects/edit", query: { id: id } });
    },
  }
}
</script>

<style scoped>

</style>